import { filter } from "lodash";

export function textLengthOverCut(txt: string, len: any, lastTxt: string) {
  if (len === "" || len == null) {
    // 기본값
    len = 20;
  }
  if (lastTxt === "" || lastTxt == null) {
    // 기본값
    lastTxt = "...";
  }
  if (txt != null && txt.length > len) {
    txt = txt.substr(0, len) + lastTxt;
  }
  return txt;
}

export function removeParenthesis(str: string) {
  try {
    return str.slice(1, str.length - 1);
  } catch (e) {
    return str;
  }
}
export function regInvalidDate(date: any) {
  if (date != null && !isNaN(date.getTime()) && date.getTime() > 0) {
    return true;
  }
  return false;
}
export function convertStringToDate(date: any) {
  if (date != null && new Date(date).getTime() > 0 && date.length === 10) {
    return true;
  }

  return false;
}

export function isEmptyObj(obj: object) {
  if (obj.constructor === Object && Object.keys(obj).length === 0) {
    return true;
  }

  return false;
}

export const reg1to100 = (number: string) => {
  if (Number(number) > 0 && Number(number) <= 100) {
    return true;
  }
  return false;
};
export const regPhoneNumber = (phoneNumber: string) => {
  try {
    const reg: RegExp = /^01([0|1|6|7|8|9])([0-9]{3,4})([0-9]{4})$/;
    if (phoneNumber === "" || !reg.test(phoneNumber)) {
      return false;
    }
    return true;
  } catch (e) {
    return false;
  }
};
export function getPhoneNumberString(phone_number: string) {
  try {
    if (phone_number.length == 10) {
      const res: string = `${phone_number.slice(0, 3)}-${phone_number.slice(
        3,
        6
      )}-${phone_number.slice(6, 10)}`;
      return res;
    }
    if (phone_number.length == 11) {
      const res: string = `${phone_number.slice(0, 3)}-${phone_number.slice(
        3,
        7
      )}-${phone_number.slice(7, 11)}`;
      return res;
    }
  } catch (e) {
    return phone_number;
  }
  return phone_number;
}

export const regID = (id: string) => {
  try {
    const reg: RegExp = /[a-zA-Z0-9]{1}[a-zA-Z0-9_]{2,19}$/;
    if (id == null) {
      return false;
    }
    if (id == "" || !reg.test(id)) {
      return false;
    }
    if (id.length > 20) {
      return false;
    }
    // var chk_num = id.search(/[0-9]/g);
    // var chk_eng = id.search(/[a-z]/ig);

    // if(chk_num < 0 || chk_eng < 0)
    // {
    //     return false;
    // }
    return true;
  } catch (e) {
    return false;
  }
};

export const regPW = (password: string) => {
  try {
    // const reg: RegExp = /^(?=.*\d)(?=.*[a-zA-Z]).{8,32}$/;
    const reg: RegExp = /^(?=.*\d).{8,32}$/;
    if (password == "" || !reg.test(password)) {
      return false;
    }
    return true;
  } catch (e) {
    return false;
  }
};

export const regEmail = (email: string) => {
  try {
    const reg: RegExp =
      /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
    if (email == "" || !reg.test(email)) {
      return false;
    }
    return true;
  } catch (e) {
    return false;
  }
};

export const regName = (name: string) => {
  try {
    const reg: RegExp = /^[ㄱ-ㅎ|가-힣|a-z|A-Z|]+$/;
    if (name == "" || !reg.test(name)) {
      return false;
    }
    return true;
  } catch (e) {
    return false;
  }
};

export const regString = (name: string) => {
  if (name == null || name == "") {
    return false;
  }
  return true;
};

export const regInviteCode = (inviteCode: string) => {
  if (inviteCode == null || inviteCode == "") {
    return false;
  }
  if (inviteCode.length != 10) {
    return false;
  }
  return true;
};

export const regPWCheck = (password: string, passwordCheck: string) => {
  if (password === passwordCheck) {
    return true;
  }
  return false;
};

export const regTypeCheck = (type: string) => {
  if (
    type == null ||
    type == "" ||
    (type != "HEAD" && type != "SHOP" && type != "NORMAL")
  ) {
    return false;
  }
  return true;
};

export const regBRN = (brn: string) => {
  try {
    const reg: RegExp = /^(\d{3,3})+[-]+(\d{2,2})+[-]+(\d{5,5})/;
    if (brn == "" || !reg.test(brn)) {
      return false;
    }
    return true;
  } catch (e) {
    return false;
  }
};

export const regOpenDate = (openDate: string) => {
  try {
    const reg: RegExp = /^(\d{4,4})+[-]+(\d{2,2})+[-]+(\d{2,2})/;
    if (openDate == "" || !reg.test(openDate)) {
      return false;
    }
    return true;
  } catch (e) {
    return false;
  }
};

const pattern = /([^가-힣\x20])/i;

export function regPattern(array: any, query: any) {
  if (query) {
    if (!isNaN(query)) {
      return filter(
        array,
        (_user) => String(_user.SHOP_ID).indexOf(query.toLowerCase()) !== -1
      );
    }
    if (isNaN(query)) {
      // 초성체크
      if (pattern.test(query)) {
        return filter(
          array,
          (_user) =>
            cho_hangul(_user.NAME)
              .toLowerCase()
              .indexOf(query.toLowerCase()) !== -1
        );
      }
      return filter(
        array,
        (_user) => _user.NAME.toLowerCase().indexOf(query.toLowerCase()) !== -1
      );
    }
  }
  return array;
}
export function cho_hangul(str: string) {
  const cho = [
    "ㄱ",
    "ㄲ",
    "ㄴ",
    "ㄷ",
    "ㄸ",
    "ㄹ",
    "ㅁ",
    "ㅂ",
    "ㅃ",
    "ㅅ",
    "ㅆ",
    "ㅇ",
    "ㅈ",
    "ㅉ",
    "ㅊ",
    "ㅋ",
    "ㅌ",
    "ㅍ",
    "ㅎ",
  ];
  let result = "";
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i) - 44032;
    if (code > -1 && code < 11172) result += cho[Math.floor(code / 588)];
    else result += str.charAt(i);
  }
  return result;
}
